import { createSelector } from "reselect";

const selectFormulariosResposta = (state) => state.formularioRespostaItemProcesso;

export const makeSelectFormularioRespostaByItemId = (idProcessoItem) => createSelector(
  [selectFormulariosResposta],
  (formularioResposta) => formularioResposta[idProcessoItem] ?? null
);
